export default __webpack_public_path__ + "static/media/SearchIcon.e00b849d.svg";